function initGlide(selectorGlide, selectorThumbs, autoplay = false, animationDuration = 500) {
    if (document.querySelector(selectorGlide)) {
        const glider = new Glide(selectorGlide, {
            animationDuration: animationDuration,
            autoplay: autoplay,
            gap: 0,
            type: autoplay ? 'carousel' : 'slider',
        });
        glider.mount();

        if (selectorThumbs) {
            const thumbs = document.querySelectorAll(selectorThumbs + ' [data-glide-dir]');

            thumbs.forEach(thumb => {
                thumb.addEventListener('click', () => {
                    glider.go(thumb.getAttribute('data-glide-dir'));
                })
            })
        }
        loadLazyImages(selectorGlide)
    }
}

function initBrandsGlide() {
    if (document.querySelector('.brands.glide')) {
        const glider = new Glide('.brands.glide', {
            // rewind: false,
            autoplay: true,
            type: 'carousel',
            gap: 64,
            animationDuration: 5000,
            time: 0,
            animationTimingFunc: 'linear',
            perView: 6,
            slidesToScroll: 1,
            rewindDuration: 0,
            breakpoints: {
                1024: {
                    perView: 5
                },
                767: {
                    perView: 3
                },
                450: {
                    perView: 2
                }
            }
        });
        glider.mount();
    }
}

function loadLazyImages(selector) {
    document.querySelectorAll(selector + ' img[loading="lazy"]').forEach((img) => {
        img.removeAttribute('loading');
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initGlide('.hero__slideshow.glide', false, 10000, 2000);
    initBrandsGlide();
});
